import { AxiosResponse } from "axios";
import { apisiseci } from "./api";

export const getService = (slug: string): Promise<AxiosResponse> => apisiseci.get(`/cms/servicos/?slug=${slug}`);